import React from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'util/sanitize/sanitizeHtml';

export const NoActiveBallots = ({ title, description, showTitle = true }) => (
  <section
    className="no-active-ballots no-ballots dashboard-card"
    data-testid={'no-active-ballots'}
  >
    {showTitle ? <h3 className="dashboard-card-header">{title}</h3> : null}
    <div className="no-ballot-content">
      <div>
        <hr />
        <p
          className="detail"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
        />
      </div>
    </div>
  </section>
);

export default NoActiveBallots;

NoActiveBallots.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  showTitle: PropTypes.bool,
};
